
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/allBrands",
      function () {
        return require("private-next-pages/brands/allBrands/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/allBrands"])
      });
    }
  